module.exports = __webpack_public_path__ + "media/images/logo_generali-0f037986.png";